import { computed } from 'vue'

// Previous competition year, using the browser's local September 16 boundary.
export function getPrisenYear (today = new Date()) {
    const currentYear = today.getFullYear()
    const currentCompetitionYear = today >= new Date(currentYear, 8, 16)
        ? currentYear + 1
        : currentYear
    return currentCompetitionYear - 1
}

export function usePrisenYear () {
    // Evaluated per consumer; like the original computed, this is not a live clock.
    const prisenyear = computed(() => getPrisenYear())
    // this will return the previous competition year.
    return { prisenyear }
}